type PropsType = {
  fill?: string;
};

const OriginalPlanIcon = ({ fill }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g opacity="0.9">
        <path
          d="M6.20733 0.325981C6.64198 -0.108657 7.35667 -0.108664 7.79131 0.325981L8.85674 1.39141C9.03902 1.57368 9.39733 1.72051 9.64971 1.72051H11.1565C11.7735 1.72051 12.2786 2.22566 12.2786 2.84258V4.34942C12.2786 4.6018 12.4254 4.96011 12.6077 5.14239L13.6731 6.20782C14.1078 6.64246 14.1078 7.35715 13.6731 7.7918L12.6077 8.85723C12.4254 9.0395 12.2786 9.39782 12.2786 9.6502V11.157C12.2786 11.774 11.7735 12.2791 11.1565 12.2791H9.64971C9.39733 12.2791 9.03902 12.4259 8.85674 12.6082L7.79131 13.6736C7.35666 14.1083 6.64198 14.1083 6.20733 13.6736L5.1419 12.6082C4.95963 12.4259 4.60131 12.2791 4.34893 12.2791H2.84209C2.22517 12.2791 1.72002 11.774 1.72002 11.157V9.6502C1.72002 9.39081 1.5732 9.03249 1.39092 8.85723L0.325492 7.7918C-0.109145 7.35715 -0.109152 6.64246 0.325492 6.20782L1.39092 5.14239C1.5732 4.96011 1.72002 4.6018 1.72002 4.34942V2.84258C1.72003 2.22566 2.22517 1.72051 2.84209 1.72051H4.34893C4.60131 1.72051 4.95963 1.57368 5.1419 1.39141L6.20733 0.325981ZM9.10284 8.39532C8.71726 8.39532 8.40166 8.71091 8.40166 9.09649C8.40173 9.48201 8.71712 9.79766 9.10967 9.79766C9.49507 9.79749 9.80297 9.48191 9.80303 9.09649C9.80303 8.71107 9.48819 8.39558 9.10284 8.39532ZM9.48077 4.51836C9.27744 4.31529 8.94083 4.31514 8.7376 4.51836L4.53155 8.72442C4.32833 8.92764 4.3285 9.26425 4.53155 9.46758C4.6367 9.57274 4.77042 9.62188 4.90362 9.62188C5.03669 9.62179 5.16965 9.57264 5.27471 9.46758L9.48077 5.26153C9.68407 5.05822 9.68407 4.72167 9.48077 4.51836ZM4.90362 4.18829C4.51804 4.18829 4.20245 4.50388 4.20245 4.88946C4.20251 5.27496 4.51793 5.5906 4.91045 5.59063C5.29599 5.59063 5.60472 5.27498 5.60479 4.88946C5.60479 4.50392 5.28914 4.18835 4.90362 4.18829Z"
          fill={fill ?? '#FF9108'}
        />
      </g>
    </svg>
  );
};

export default OriginalPlanIcon;
